const getters = {
  token: state => {
    return state.user.token
  },
  usessionid: state => {
    return state.user.usessionid
  },
  restoken: state => {
    return state.user.restoken
  },
  user: state => {
    return state.user
  },
  currentmenu: state => {
    return state.activity.currentmenu
  },
  currentact: state => {
    return state.activity
  }
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js